import React from 'react';

export const UserOrdersListHeader = () => {
    return (
        <li className="list-group-item">
            <div className="row d-flex d-lg-none">
                <div className="col">
                    <h3 className="text-center h4 lg-0">Orders</h3>
                </div>
            </div>
            <div className="row d-none d-lg-flex">
                <div className="more-header col-lg-1 col-xl-1" />
                <div className="date-header col-lg-3 col-xl-2">
                    <p className="text-start my-1">
                        <strong>Date</strong>
                    </p>
                </div>
                <div className="status-header col-lg-2 col-xl-2">
                    <p className="text-center my-1">
                        <strong>Status</strong>
                    </p>
                </div>
                <div className="total-header col-lg-3 col-xl-4">
                    <p className="text-end my-1">
                        <strong>Total</strong>
                    </p>
                </div>
                <div className="actions-header col-lg-3 col-xl-3">
                    <p className="text-end my-1">
                        <strong>Actions</strong>
                    </p>
                </div>
            </div>
        </li>
    );
};
